(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-disc]');
    if (!root) return;
    var DE = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
    var appliedEl = root.querySelector('[data-disc-applied]');
    var codeEl = root.querySelector('[data-disc-applied-code]');
    var saveEl = root.querySelector('[data-disc-applied-save]');
    var lineEl = document.querySelector('[data-disc-line]');
    var lineCode = document.querySelector('[data-disc-line-code]');
    var lineAmt = document.querySelector('[data-disc-line-amount]');

    function money(cents) { return '€' + (Math.abs(cents) / 100).toFixed(2).replace('.', ','); }
    function show(el, on) { if (el) { el.hidden = !on; } }

    function render(cart) {
      var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
      if (codes.length) {
        var names = codes.map(function (c) { return c.code; }).join(', ');
        if (codeEl) codeEl.textContent = names;
        if (saveEl) saveEl.textContent = (DE ? 'Du sparst ' : 'You save ') + money(cart.total_discount);
        if (lineCode) lineCode.textContent = '(' + names + ')';
        if (lineAmt) lineAmt.textContent = '−' + money(cart.total_discount);
        show(appliedEl, true); show(lineEl, true);
      } else {
        show(appliedEl, false); show(lineEl, false);
      }
    }

    // Cross-Sell "Hinzufuegen" per AJAX (kein verschachteltes Form -> Checkout bleibt intakt)
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-rec-add]');
      if (!add) return;
      var vid = parseInt(add.getAttribute('data-rec-vid'), 10);
      if (!vid || add.disabled) return;
      var quantity = Math.max(1, parseInt(add.getAttribute('data-rec-quantity'), 10) || 1);
      var status = add.closest('.cr-cart__rec').querySelector('[data-rec-status]');
      var failure = DE ? 'Der Artikel konnte nicht zum Warenkorb hinzugefügt werden. Bitte prüfe deinen Warenkorb und versuche es erneut.' : 'The item could not be added. Please check your cart and try again.';
      if (status) { status.hidden = true; status.textContent = ''; }
      add.disabled = true;
      // Vorbestellte Ware traegt beide Eigenschaften mit, sonst entstuende hier
      // eine Vorbestellung ohne Liefertermin.
      var nutzlast = { id: vid, quantity: quantity };
      var pname = add.getAttribute('data-rec-prop-name');
      if (pname) {
        nutzlast.properties = {};
        nutzlast.properties[pname] = add.getAttribute('data-rec-prop-value');
        nutzlast.properties['_eta'] = add.getAttribute('data-rec-eta');
      }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(nutzlast) })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              if (error && typeof error.description === 'string') failure = error.description;
              throw new Error('Cart request rejected');
            });
          }
          window.location.reload();
        })
        .catch(function () {
          add.disabled = false;
          if (status) { status.textContent = failure; status.hidden = false; }
        });
    });

    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(render).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
